export const status = {
  active: 'Active',
  inactive: 'Inactive',
  available: 'Available',
  occupied: 'Occupied',
  offline: 'Offline',
  maintenance: 'Maintenance',
  error: 'Error',
  charging: 'Charging',
  completed: 'Completed',
  cancelled: 'Cancelled',
  pending: 'Pending',
};